

export default {
  name: "default",
  async mounted(){
    await this.$store.dispatch("store/retrieveSettings");
    this.$nextTick(() => {
      this.loaded = true
    })
  },
  created(){
    console.log(this.$store.state.settings, 'llllllllllllllllllllllllllllllllll')
  }
}
